/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfGetGroupPriceCategoriesListDto } from '../models/custom-result-of-get-group-price-categories-list-dto';
import { CustomResultOfListOfGetGroupPriceCategoriesListDto } from '../models/custom-result-of-list-of-get-group-price-categories-list-dto';
import { CustomResultOfPaginatedListOfGetGroupPriceCategoriesWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-group-price-categories-with-pagination-dto';
import { groupPriceCategoriesCreateGet } from '../fn/group-price-categories/group-price-categories-create-get';
import { GroupPriceCategoriesCreateGet$Params } from '../fn/group-price-categories/group-price-categories-create-get';
import { groupPriceCategoriesCreateGroupPriceCategoryByExistingCategoryGet } from '../fn/group-price-categories/group-price-categories-create-group-price-category-by-existing-category-get';
import { GroupPriceCategoriesCreateGroupPriceCategoryByExistingCategoryGet$Params } from '../fn/group-price-categories/group-price-categories-create-group-price-category-by-existing-category-get';
import { groupPriceCategoriesCreateGroupPriceCategoryByExistingCategoryPost } from '../fn/group-price-categories/group-price-categories-create-group-price-category-by-existing-category-post';
import { GroupPriceCategoriesCreateGroupPriceCategoryByExistingCategoryPost$Params } from '../fn/group-price-categories/group-price-categories-create-group-price-category-by-existing-category-post';
import { groupPriceCategoriesCreatePost } from '../fn/group-price-categories/group-price-categories-create-post';
import { GroupPriceCategoriesCreatePost$Params } from '../fn/group-price-categories/group-price-categories-create-post';
import { groupPriceCategoriesDelete } from '../fn/group-price-categories/group-price-categories-delete';
import { GroupPriceCategoriesDelete$Params } from '../fn/group-price-categories/group-price-categories-delete';
import { groupPriceCategoriesGetGroupPriceCategoriesAuditWithPagination } from '../fn/group-price-categories/group-price-categories-get-group-price-categories-audit-with-pagination';
import { GroupPriceCategoriesGetGroupPriceCategoriesAuditWithPagination$Params } from '../fn/group-price-categories/group-price-categories-get-group-price-categories-audit-with-pagination';
import { groupPriceCategoriesGetGroupPriceCategoriesList } from '../fn/group-price-categories/group-price-categories-get-group-price-categories-list';
import { GroupPriceCategoriesGetGroupPriceCategoriesList$Params } from '../fn/group-price-categories/group-price-categories-get-group-price-categories-list';
import { groupPriceCategoriesGetGroupPriceCategoriesWithPagination } from '../fn/group-price-categories/group-price-categories-get-group-price-categories-with-pagination';
import { GroupPriceCategoriesGetGroupPriceCategoriesWithPagination$Params } from '../fn/group-price-categories/group-price-categories-get-group-price-categories-with-pagination';
import { groupPriceCategoriesUpdateGet } from '../fn/group-price-categories/group-price-categories-update-get';
import { GroupPriceCategoriesUpdateGet$Params } from '../fn/group-price-categories/group-price-categories-update-get';
import { groupPriceCategoriesUpdatePut } from '../fn/group-price-categories/group-price-categories-update-put';
import { GroupPriceCategoriesUpdatePut$Params } from '../fn/group-price-categories/group-price-categories-update-put';

@Injectable({ providedIn: 'root' })
export class GroupPriceCategoriesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `groupPriceCategoriesCreateGet()` */
  static readonly GroupPriceCategoriesCreateGetPath = '/GroupPriceCategories/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupPriceCategoriesCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPriceCategoriesCreateGet$Response(params?: GroupPriceCategoriesCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return groupPriceCategoriesCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `groupPriceCategoriesCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPriceCategoriesCreateGet(params?: GroupPriceCategoriesCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.groupPriceCategoriesCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `groupPriceCategoriesCreatePost()` */
  static readonly GroupPriceCategoriesCreatePostPath = '/GroupPriceCategories/Create';

  /**
   * Create new group price category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupPriceCategoriesCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupPriceCategoriesCreatePost$Response(params: GroupPriceCategoriesCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return groupPriceCategoriesCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create new group price category.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `groupPriceCategoriesCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupPriceCategoriesCreatePost(params: GroupPriceCategoriesCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.groupPriceCategoriesCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `groupPriceCategoriesUpdateGet()` */
  static readonly GroupPriceCategoriesUpdateGetPath = '/GroupPriceCategories/Update';

  /**
   * Get group price category by Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupPriceCategoriesUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPriceCategoriesUpdateGet$Response(params?: GroupPriceCategoriesUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetGroupPriceCategoriesListDto>> {
    return groupPriceCategoriesUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get group price category by Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `groupPriceCategoriesUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPriceCategoriesUpdateGet(params?: GroupPriceCategoriesUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfGetGroupPriceCategoriesListDto> {
    return this.groupPriceCategoriesUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetGroupPriceCategoriesListDto>): CustomResultOfGetGroupPriceCategoriesListDto => r.body)
    );
  }

  /** Path part for operation `groupPriceCategoriesUpdatePut()` */
  static readonly GroupPriceCategoriesUpdatePutPath = '/GroupPriceCategories/Update';

  /**
   * Update group price category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupPriceCategoriesUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupPriceCategoriesUpdatePut$Response(params: GroupPriceCategoriesUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return groupPriceCategoriesUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update group price category.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `groupPriceCategoriesUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupPriceCategoriesUpdatePut(params: GroupPriceCategoriesUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.groupPriceCategoriesUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `groupPriceCategoriesDelete()` */
  static readonly GroupPriceCategoriesDeletePath = '/GroupPriceCategories';

  /**
   * Delete group price category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupPriceCategoriesDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPriceCategoriesDelete$Response(params?: GroupPriceCategoriesDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return groupPriceCategoriesDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete group price category.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `groupPriceCategoriesDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPriceCategoriesDelete(params?: GroupPriceCategoriesDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.groupPriceCategoriesDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `groupPriceCategoriesGetGroupPriceCategoriesList()` */
  static readonly GroupPriceCategoriesGetGroupPriceCategoriesListPath = '/GroupPriceCategories/GetGroupPriceCategoriesList';

  /**
   * Get group price categories List drop down.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupPriceCategoriesGetGroupPriceCategoriesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPriceCategoriesGetGroupPriceCategoriesList$Response(params?: GroupPriceCategoriesGetGroupPriceCategoriesList$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetGroupPriceCategoriesListDto>> {
    return groupPriceCategoriesGetGroupPriceCategoriesList(this.http, this.rootUrl, params, context);
  }

  /**
   * Get group price categories List drop down.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `groupPriceCategoriesGetGroupPriceCategoriesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPriceCategoriesGetGroupPriceCategoriesList(params?: GroupPriceCategoriesGetGroupPriceCategoriesList$Params, context?: HttpContext): Observable<CustomResultOfListOfGetGroupPriceCategoriesListDto> {
    return this.groupPriceCategoriesGetGroupPriceCategoriesList$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetGroupPriceCategoriesListDto>): CustomResultOfListOfGetGroupPriceCategoriesListDto => r.body)
    );
  }

  /** Path part for operation `groupPriceCategoriesGetGroupPriceCategoriesWithPagination()` */
  static readonly GroupPriceCategoriesGetGroupPriceCategoriesWithPaginationPath = '/GroupPriceCategories/GetGroupPriceCategoriesWithPagination';

  /**
   * Get group price categories WithPagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupPriceCategoriesGetGroupPriceCategoriesWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupPriceCategoriesGetGroupPriceCategoriesWithPagination$Response(params: GroupPriceCategoriesGetGroupPriceCategoriesWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetGroupPriceCategoriesWithPaginationDto>> {
    return groupPriceCategoriesGetGroupPriceCategoriesWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get group price categories WithPagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `groupPriceCategoriesGetGroupPriceCategoriesWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupPriceCategoriesGetGroupPriceCategoriesWithPagination(params: GroupPriceCategoriesGetGroupPriceCategoriesWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetGroupPriceCategoriesWithPaginationDto> {
    return this.groupPriceCategoriesGetGroupPriceCategoriesWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetGroupPriceCategoriesWithPaginationDto>): CustomResultOfPaginatedListOfGetGroupPriceCategoriesWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `groupPriceCategoriesGetGroupPriceCategoriesAuditWithPagination()` */
  static readonly GroupPriceCategoriesGetGroupPriceCategoriesAuditWithPaginationPath = '/GroupPriceCategories/GetGroupPriceCategoriesAuditWithPagination';

  /**
   * Get group price categories audit WithPagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupPriceCategoriesGetGroupPriceCategoriesAuditWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupPriceCategoriesGetGroupPriceCategoriesAuditWithPagination$Response(params: GroupPriceCategoriesGetGroupPriceCategoriesAuditWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return groupPriceCategoriesGetGroupPriceCategoriesAuditWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get group price categories audit WithPagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `groupPriceCategoriesGetGroupPriceCategoriesAuditWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupPriceCategoriesGetGroupPriceCategoriesAuditWithPagination(params: GroupPriceCategoriesGetGroupPriceCategoriesAuditWithPagination$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.groupPriceCategoriesGetGroupPriceCategoriesAuditWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `groupPriceCategoriesCreateGroupPriceCategoryByExistingCategoryGet()` */
  static readonly GroupPriceCategoriesCreateGroupPriceCategoryByExistingCategoryGetPath = '/GroupPriceCategories/CreateGroupPriceCategoryByExistingCategory';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupPriceCategoriesCreateGroupPriceCategoryByExistingCategoryGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPriceCategoriesCreateGroupPriceCategoryByExistingCategoryGet$Response(params?: GroupPriceCategoriesCreateGroupPriceCategoryByExistingCategoryGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return groupPriceCategoriesCreateGroupPriceCategoryByExistingCategoryGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `groupPriceCategoriesCreateGroupPriceCategoryByExistingCategoryGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPriceCategoriesCreateGroupPriceCategoryByExistingCategoryGet(params?: GroupPriceCategoriesCreateGroupPriceCategoryByExistingCategoryGet$Params, context?: HttpContext): Observable<Blob> {
    return this.groupPriceCategoriesCreateGroupPriceCategoryByExistingCategoryGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `groupPriceCategoriesCreateGroupPriceCategoryByExistingCategoryPost()` */
  static readonly GroupPriceCategoriesCreateGroupPriceCategoryByExistingCategoryPostPath = '/GroupPriceCategories/CreateGroupPriceCategoryByExistingCategory';

  /**
   * Create Group Price Category By Existing Category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupPriceCategoriesCreateGroupPriceCategoryByExistingCategoryPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupPriceCategoriesCreateGroupPriceCategoryByExistingCategoryPost$Response(params: GroupPriceCategoriesCreateGroupPriceCategoryByExistingCategoryPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return groupPriceCategoriesCreateGroupPriceCategoryByExistingCategoryPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Group Price Category By Existing Category.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `groupPriceCategoriesCreateGroupPriceCategoryByExistingCategoryPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupPriceCategoriesCreateGroupPriceCategoryByExistingCategoryPost(params: GroupPriceCategoriesCreateGroupPriceCategoryByExistingCategoryPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.groupPriceCategoriesCreateGroupPriceCategoryByExistingCategoryPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

}
